export default [
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(10).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(10).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(11).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(11).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(12).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(12).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(13).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(13).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(19).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(19).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(22).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(22).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(4).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(4).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Foto_(9).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Foto_(9).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Juli_1996.jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Juli_1996.jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Mittwoch,_17._Juni_2009_(2).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Mittwoch,_17._Juni_2009_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Mittwoch,_17._Juni_2009_(3).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Mittwoch,_17._Juni_2009_(3).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Montag,_15._Juni_2009_(2).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Montag,_15._Juni_2009_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Montag,_15._Juni_2009_(3).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Montag,_15._Juni_2009_(3).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Montag,_15._Juni_2009_(4).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Montag,_15._Juni_2009_(4).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Montag,_15._Juni_2009_(6).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Montag,_15._Juni_2009_(6).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Schuetzenfest_Hartegasse_2007.jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Schuetzenfest_Hartegasse_2007.jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Sonntag,_14._Juni_2009_(3).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Sonntag,_14._Juni_2009_(3).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Sonntag,_14._Juni_2009_(5).jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Sonntag,_14._Juni_2009_(5).jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/Sonntag,_14._Juni_2009.jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/Sonntag,_14._Juni_2009.jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/TK_in_St._Remo_1998.jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/TK_in_St._Remo_1998.jpg")
  },
  {
    original: require("../images/gallery/TK_aus_frueheren_jahren/TK_in_Thier_1999.jpg"),
    thumbnail: require("../images/gallery/TK_aus_frueheren_jahren/thumb/TK_in_Thier_1999.jpg")
  }
];



// WEBPACK FOOTER //
// ./src/components/gallerylists/imagesold.js